import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from './router/index'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    languages: {
      en:'English',
      zh:'简体中文'
    },
    countries: {
      '' : 'Worldwide',
      'AF' : 'Afghanistan',
      'AX' : 'Aland Islands',
      'AL' : 'Albania',
      'DZ' : 'Algeria',
      'AS' : 'American Samoa',
      'AD' : 'Andorra',
      'AO' : 'Angola',
      'AI' : 'Anguilla',
      'AQ' : 'Antarctica',
      'AG' : 'Antigua And Barbuda',
      'AR' : 'Argentina',
      'AM' : 'Armenia',
      'AW' : 'Aruba',
      'AU' : 'Australia',
      'AT' : 'Austria',
      'AZ' : 'Azerbaijan',
      'BS' : 'Bahamas',
      'BH' : 'Bahrain',
      'BD' : 'Bangladesh',
      'BB' : 'Barbados',
      'BY' : 'Belarus',
      'BE' : 'Belgium',
      'BZ' : 'Belize',
      'BJ' : 'Benin',
      'BM' : 'Bermuda',
      'BT' : 'Bhutan',
      'BO' : 'Bolivia',
      'BA' : 'Bosnia And Herzegovina',
      'BW' : 'Botswana',
      'BV' : 'Bouvet Island',
      'BR' : 'Brazil',
      'IO' : 'British Indian Ocean Territory',
      'BN' : 'Brunei Darussalam',
      'BG' : 'Bulgaria',
      'BF' : 'Burkina Faso',
      'BI' : 'Burundi',
      'KH' : 'Cambodia',
      'CM' : 'Cameroon',
      'CA' : 'Canada',
      'CV' : 'Cape Verde',
      'KY' : 'Cayman Islands',
      'CF' : 'Central African Republic',
      'TD' : 'Chad',
      'CL' : 'Chile',
      'CN' : 'China',
      'CX' : 'Christmas Island',
      'CC' : 'Cocos (Keeling) Islands',
      'CO' : 'Colombia',
      'KM' : 'Comoros',
      'CG' : 'Congo',
      'CD' : 'Congo, Democratic Republic',
      'CK' : 'Cook Islands',
      'CR' : 'Costa Rica',
      'CI' : 'Cote D\'Ivoire',
      'HR' : 'Croatia',
      'CU' : 'Cuba',
      'CY' : 'Cyprus',
      'CZ' : 'Czech Republic',
      'DK' : 'Denmark',
      'DJ' : 'Djibouti',
      'DM' : 'Dominica',
      'DO' : 'Dominican Republic',
      'EC' : 'Ecuador',
      'EG' : 'Egypt',
      'SV' : 'El Salvador',
      'GQ' : 'Equatorial Guinea',
      'ER' : 'Eritrea',
      'EE' : 'Estonia',
      'ET' : 'Ethiopia',
      'FK' : 'Falkland Islands (Malvinas)',
      'FO' : 'Faroe Islands',
      'FJ' : 'Fiji',
      'FI' : 'Finland',
      'FR' : 'France',
      'GF' : 'French Guiana',
      'PF' : 'French Polynesia',
      'TF' : 'French Southern Territories',
      'GA' : 'Gabon',
      'GM' : 'Gambia',
      'GE' : 'Georgia',
      'DE' : 'Germany',
      'GH' : 'Ghana',
      'GI' : 'Gibraltar',
      'GR' : 'Greece',
      'GL' : 'Greenland',
      'GD' : 'Grenada',
      'GP' : 'Guadeloupe',
      'GU' : 'Guam',
      'GT' : 'Guatemala',
      'GG' : 'Guernsey',
      'GN' : 'Guinea',
      'GW' : 'Guinea-Bissau',
      'GY' : 'Guyana',
      'HT' : 'Haiti',
      'HM' : 'Heard Island & Mcdonald Islands',
      'VA' : 'Holy See (Vatican City State)',
      'HN' : 'Honduras',
      'HK' : 'Hong Kong',
      'HU' : 'Hungary',
      'IS' : 'Iceland',
      'IN' : 'India',
      'ID' : 'Indonesia',
      'IR' : 'Iran, Islamic Republic Of',
      'IQ' : 'Iraq',
      'IE' : 'Ireland',
      'IM' : 'Isle Of Man',
      'IL' : 'Israel',
      'IT' : 'Italy',
      'JM' : 'Jamaica',
      'JP' : 'Japan',
      'JE' : 'Jersey',
      'JO' : 'Jordan',
      'KZ' : 'Kazakhstan',
      'KE' : 'Kenya',
      'KI' : 'Kiribati',
      'KR' : 'Korea',
      'KW' : 'Kuwait',
      'KG' : 'Kyrgyzstan',
      'LA' : 'Lao People\'s Democratic Republic',
      'LV' : 'Latvia',
      'LB' : 'Lebanon',
      'LS' : 'Lesotho',
      'LR' : 'Liberia',
      'LY' : 'Libyan Arab Jamahiriya',
      'LI' : 'Liechtenstein',
      'LT' : 'Lithuania',
      'LU' : 'Luxembourg',
      'MO' : 'Macao',
      'MK' : 'Macedonia',
      'MG' : 'Madagascar',
      'MW' : 'Malawi',
      'MY' : 'Malaysia',
      'MV' : 'Maldives',
      'ML' : 'Mali',
      'MT' : 'Malta',
      'MH' : 'Marshall Islands',
      'MQ' : 'Martinique',
      'MR' : 'Mauritania',
      'MU' : 'Mauritius',
      'YT' : 'Mayotte',
      'MX' : 'Mexico',
      'FM' : 'Micronesia, Federated States Of',
      'MD' : 'Moldova',
      'MC' : 'Monaco',
      'MN' : 'Mongolia',
      'ME' : 'Montenegro',
      'MS' : 'Montserrat',
      'MA' : 'Morocco',
      'MZ' : 'Mozambique',
      'MM' : 'Myanmar',
      'NA' : 'Namibia',
      'NR' : 'Nauru',
      'NP' : 'Nepal',
      'NL' : 'Netherlands',
      'AN' : 'Netherlands Antilles',
      'NC' : 'New Caledonia',
      'NZ' : 'New Zealand',
      'NI' : 'Nicaragua',
      'NE' : 'Niger',
      'NG' : 'Nigeria',
      'NU' : 'Niue',
      'NF' : 'Norfolk Island',
      'MP' : 'Northern Mariana Islands',
      'NO' : 'Norway',
      'OM' : 'Oman',
      'PK' : 'Pakistan',
      'PW' : 'Palau',
      'PS' : 'Palestinian Territory, Occupied',
      'PA' : 'Panama',
      'PG' : 'Papua New Guinea',
      'PY' : 'Paraguay',
      'PE' : 'Peru',
      'PH' : 'Philippines',
      'PN' : 'Pitcairn',
      'PL' : 'Poland',
      'PT' : 'Portugal',
      'PR' : 'Puerto Rico',
      'QA' : 'Qatar',
      'RE' : 'Reunion',
      'RO' : 'Romania',
      'RU' : 'Russian Federation',
      'RW' : 'Rwanda',
      'BL' : 'Saint Barthelemy',
      'SH' : 'Saint Helena',
      'KN' : 'Saint Kitts And Nevis',
      'LC' : 'Saint Lucia',
      'MF' : 'Saint Martin',
      'PM' : 'Saint Pierre And Miquelon',
      'VC' : 'Saint Vincent And Grenadines',
      'WS' : 'Samoa',
      'SM' : 'San Marino',
      'ST' : 'Sao Tome And Principe',
      'SA' : 'Saudi Arabia',
      'SN' : 'Senegal',
      'RS' : 'Serbia',
      'SC' : 'Seychelles',
      'SL' : 'Sierra Leone',
      'SG' : 'Singapore',
      'SK' : 'Slovakia',
      'SI' : 'Slovenia',
      'SB' : 'Solomon Islands',
      'SO' : 'Somalia',
      'ZA' : 'South Africa',
      'GS' : 'South Georgia And Sandwich Isl.',
      'ES' : 'Spain',
      'LK' : 'Sri Lanka',
      'SD' : 'Sudan',
      'SR' : 'Suriname',
      'SJ' : 'Svalbard And Jan Mayen',
      'SZ' : 'Swaziland',
      'SE' : 'Sweden',
      'CH' : 'Switzerland',
      'SY' : 'Syrian Arab Republic',
      'TW' : 'Taiwan',
      'TJ' : 'Tajikistan',
      'TZ' : 'Tanzania',
      'TH' : 'Thailand',
      'TL' : 'Timor-Leste',
      'TG' : 'Togo',
      'TK' : 'Tokelau',
      'TO' : 'Tonga',
      'TT' : 'Trinidad And Tobago',
      'TN' : 'Tunisia',
      'TR' : 'Turkey',
      'TM' : 'Turkmenistan',
      'TC' : 'Turks And Caicos Islands',
      'TV' : 'Tuvalu',
      'UG' : 'Uganda',
      'UA' : 'Ukraine',
      'AE' : 'United Arab Emirates',
      'GB' : 'United Kingdom',
      'US' : 'United States',
      'UM' : 'United States Outlying Islands',
      'UY' : 'Uruguay',
      'UZ' : 'Uzbekistan',
      'VU' : 'Vanuatu',
      'VE' : 'Venezuela',
      'VN' : 'Viet Nam',
      'VG' : 'Virgin Islands, British',
      'VI' : 'Virgin Islands, U.S.',
      'WF' : 'Wallis And Futuna',
      'EH' : 'Western Sahara',
      'YE' : 'Yemen',
      'ZM' : 'Zambia',
      'ZW' : 'Zimbabwe'
    },
    gt_timeframe : {
      'all' : 'All',
      //'now 1-H' : 'Past Hour',
      //'now 4-H' : 'Past 4 Hours',
      'now 1-d' : 'Past Day',
      'now 7-d' : 'Past 7 Days',
      'today 1-m' : 'Past Month',
      'today 3-m' : 'Past 3 Months',
      'today 1-y' : 'Past 12 Months',
      'today 5-y' : 'Past 5 Years',
      'datetimerange' : 'Datetime Range'
    },
    //user: {},
    userPermissions: [],
    lang: {},
    //program: null,
    //base64img: null,
    //items: null,
    //selectedItem: null,
    selectedTab: null,
    saveModule: null
  },
  actions: {
    // user(context,token){
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    //   axios.get('api/user')
    //     .then(function(response) {
    //       context.commit('user', response.data)
    //     })
    //     .catch(function(error) {
    //       //console.log('stifpler', error.response.data)
    //       if(error.response.data.error === "Unauthenticated."){
    //         alert("Unauthenticated.");
    //         localStorage.removeItem('token')
    //         localStorage.removeItem('expiration');
    //         location.reload();
    //       }
    //     })
    // },
    userPermissions(context, module) {
      return axios.get(`/user/sys/permissions/${module}`)
        .then(response => {
          // Assuming response.data is an array of permission objects or strings
          // Adjust if needed based on actual API response structure
          const permissions = response.data.permissions || response.data || [];
          context.commit('userPermissions', permissions);
          return permissions;
        })
        .catch(error => {
          // console.log(`stifpler | error.response: ${error.response.status}`)
          if (error.response.status === 401) {
            localStorage.removeItem('username')
            localStorage.removeItem('token')
            localStorage.removeItem('expiration')
            router.push('/login');
          }
          console.error('Failed to fetch user permissions:', error);
          context.commit('userPermissions', []);
          return [];
        })
    },
    lang(context,lang){
      axios.get('api/locale/'+lang)
        .then(function(response) {
          context.commit('lang', response.data)
        })
    },
    // program(context,program){
    //   context.commit('program', program);
    // },
    // base64img(context,base64img){
    //   context.commit('base64img', base64img);
    // },
    // items(context,items){
    //   context.commit('items', items);
    // },
    // selectedItem(context,selectedItem){
    //   context.commit('selectedItem', selectedItem);
    // },
    selectedTab(context,tab){
      context.commit('selectedItem', tab);
    },
    saveModule(context,i){
      context.commit('saveModule', i);
    }
  },
  mutations: {
    // user(state, data){
    //   return state.user = data;
    // },
    userPermissions(state, permissions) {
      state.userPermissions = permissions
    },
    lang(state, data){
      return state.lang = data;
    },
    // program(state, data){
    //   return state.program = data;
    // },
    // base64img(state, data){
    //   return state.base64img = data;
    // },
    // items(state, data){
    //   return state.items = data;
    // },
    // selectedItem(state, data){
    //   return state.selectedItem = data;
    // },
    selectedTab(state, data){
      return state.selectedTab = data;
    },
    saveModule(state, data){
      return state.saveModule = data;
    }
  },
  getters: {
    userPermissions(state) {
      return state.userPermissions
    },
    languages(state){
      return state.languages;
    },
    countries(state){
      return state.countries;
    },
    gt_timeframe(state){
      return state.gt_timeframe;
    },
    // user(state){
    //   return state.user;
    // },
    lang(state){
      return state.lang;
    },
    // program(state){
    //   return state.program;
    // },
    // base64img(state){
    //   return state.base64img;
    // },
    // items(state){
    //   return state.items;
    // },
    // selectedItem(state){
    //   return state.selectedItem;
    // },
    selectedTab(state){
      return state.selectedTab;
    },
    saveModule(state){
      return state.saveModule;
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store.js